"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../Constant");

var _Constant2 = require("../Dashboard/Constant");

var _theme, _theme2, _theme3, _theme4, _theme5;

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  background-color: ", ";\n  font-size: 1.2rem;\n  font-weight: 700;\n\n  a,\n  button,\n  span {\n    color: ", ";\n    cursor: pointer;\n    display: block;\n    font-size: 1.2rem;\n    font-weight: 700;\n    padding: 13px;\n    border: 1px solid transparent;\n    background-color: transparent;\n    text-decoration: none;\n    text-align: left;\n    width: 100%;\n    outline: none;\n\n    &:hover {\n      ", "\n      text-decoration-color: currentcolor;\n      text-decoration-line: underline;\n    }\n\n    /* Focus styles on on keyboard focus */\n    &[data-focus-visible-added]:focus {\n      outline: 4px solid ", ";\n      outline-offset: -4px;\n    }\n\n    &:active {\n      ", "\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  width: 100%;\n  z-index: 50;\n  box-shadow: 0px 10px 0px rgba(0, 0, 0, 0.14);\n  transform: scale(", ");\n\n  @media print, screen and (min-width: ", "px) {\n    position: absolute;\n    width: auto;\n    min-width: 170px;\n    box-shadow: -10px 10px 0px rgba(0, 0, 0, 0.14);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background: none;\n  color: inherit;\n  border: none;\n  font: inherit;\n  cursor: pointer;\n  outline: none;\n\n  /* Focus styles on on keyboard focus */\n  &[data-focus-visible-added]:focus {\n    ", "\n    outline-offset: 6px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  @media print, screen and (min-width: ", "px) {\n    position: relative;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var toggleFocusStyles = (0, _styledTheming.default)('mode', (_theme = {
  caliber: "outline: 4px solid ".concat(_Constant.Color.CALIBER_BLUE, ";")
}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, "outline: 4px solid ".concat(_Constant.Color.HOMEBRIDGE_BLUE)), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, "outline: 4px solid ".concat(_Constant.Color.SYNERGY_ONE_YELLOW_DARK, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, "outline: 4px solid ".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED, ";")), (0, _defineProperty2.default)(_theme, "homepoint", "outline: 4px solid ".concat(_Constant.Color.HOMEPOINT_BLUE, ";")), (0, _defineProperty2.default)(_theme, "figure", "outline: 4px solid ".concat(_Constant2.Color.FOCUS, ";")), (0, _defineProperty2.default)(_theme, "petersendean", "outline: 4px solid ".concat(_Constant2.Color.FOCUS, ";")), (0, _defineProperty2.default)(_theme, "pella", "outline: 4px solid ".concat(_Constant2.Color.FOCUS, ";")), _theme));
var itemHoverStyles = (0, _styledTheming.default)('mode', (_theme2 = {
  caliber: "\n    background-color: ".concat(_Constant.Color.GREY_3, ";\n    color: ").concat(_Constant2.Color.DARK_GREY, ";\n  ")
}, (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEBRIDGE, "\n    background-color: ".concat(_Constant.Color.HOMEBRIDGE_BLUE, ";\n    color: ").concat(_Constant2.Color.WHITE, ";\n  ")), (0, _defineProperty2.default)(_theme2, "homepoint", "\n    background-color: ".concat(_Constant.Color.GREY_3, ";\n    color: ").concat(_Constant2.Color.DARK_GREY, ";\n  ")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.SYNERGY_ONE, "\n    background-color: ".concat(_Constant.Color.BLACK, ";\n    color: ").concat(_Constant2.Color.WHITE, ";\n  ")), (0, _defineProperty2.default)(_theme2, "figure", "color: ".concat(_Constant2.Color.PURPLE, ";")), (0, _defineProperty2.default)(_theme2, "pella", "color: ".concat(_Constant2.Color.PURPLE, ";")), (0, _defineProperty2.default)(_theme2, "petersendean", "color: ".concat(_Constant2.Color.PURPLE, ";")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.GUARANTEED_RATE, "\n    color: ".concat(_Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY, "; \n    background-color: ").concat(_Constant2.Color.GREY_3, ";\n    font-weight: 700;\n  ")), _theme2));
var itemActiveStyles = (0, _styledTheming.default)('mode', (_theme3 = {
  figure: "\n    color: ".concat(_Constant2.Color.WHITE, ";\n    background-color: ").concat(_Constant2.Color.PURPLE, ";\n  ")
}, (0, _defineProperty2.default)(_theme3, _Constant.Themes.HOMEBRIDGE, "\n    background-color: ".concat(_Constant.Color.BLACK, ";\n    color: ").concat(_Constant2.Color.WHITE, ";\n  ")), (0, _defineProperty2.default)(_theme3, _Constant.Themes.GUARANTEED_RATE, "\n  background-color: ".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED, ";\n  color: ").concat(_Constant2.Color.WHITE, ";\n")), (0, _defineProperty2.default)(_theme3, _Constant.Themes.SYNERGY_ONE, "\n    background-color: ".concat(_Constant.Color.BLACK, ";\n    color: ").concat(_Constant2.Color.WHITE, ";\n  ")), (0, _defineProperty2.default)(_theme3, "pella", "\n    color: ".concat(_Constant2.Color.WHITE, ";\n    background-color: ").concat(_Constant2.Color.PURPLE, ";\n  ")), (0, _defineProperty2.default)(_theme3, "petersendean", "\n    color: ".concat(_Constant2.Color.WHITE, ";\n    background-color: ").concat(_Constant2.Color.PURPLE, ";\n  ")), _theme3));
var itemFocusStyles = (0, _styledTheming.default)('mode', (_theme4 = {
  caliber: _Constant.Color.CALIBER_BLUE
}, (0, _defineProperty2.default)(_theme4, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme4, "homepoint", _Constant.Color.HOMEPOINT_BLUE), (0, _defineProperty2.default)(_theme4, _Constant.Themes.SYNERGY_ONE, _Constant.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme4, "figure", _Constant2.Color.FOCUS_B), (0, _defineProperty2.default)(_theme4, "pella", _Constant2.Color.FOCUS_B), (0, _defineProperty2.default)(_theme4, "petersendean", _Constant2.Color.FOCUS_B), (0, _defineProperty2.default)(_theme4, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY), _theme4));
var dropdownText = (0, _styledTheming.default)('mode', (_theme5 = {
  caliber: _Constant.Color.BLACK_SOUL
}, (0, _defineProperty2.default)(_theme5, _Constant.Themes.HOMEBRIDGE, _Constant.Color.BLACK_SOUL), (0, _defineProperty2.default)(_theme5, "homepoint", _Constant.Color.BLACK_SOUL), (0, _defineProperty2.default)(_theme5, _Constant.Themes.SYNERGY_ONE, _Constant.Color.BLACK_SOUL), (0, _defineProperty2.default)(_theme5, "figure", _Constant2.Color.PURPLE), (0, _defineProperty2.default)(_theme5, "pella", _Constant2.Color.BLACK_SOUL), (0, _defineProperty2.default)(_theme5, "petersendean", _Constant2.Color.BLACK_SOUL), (0, _defineProperty2.default)(_theme5, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.BLACK_SOUL), _theme5));

var Container = _styledComponents.default.div(_templateObject(), _Constant.Width.MD);

var Toggle = _styledComponents.default.button(_templateObject2(), toggleFocusStyles);

var DropdownMenu = _styledComponents.default.ul(_templateObject3(), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? 1 : 0;
}, _Constant.Width.MD);

var DropdownItem = _styledComponents.default.li(_templateObject4(), dropdownText, _Constant2.Color.GREY_2, dropdownText, itemHoverStyles, itemFocusStyles, itemActiveStyles);

var normalizeIndex = function normalizeIndex(index, numItems) {
  return index >= numItems ? 0 : index < 0 ? numItems - 1 : index;
};
/**
 * @note the on-hover color is the Figure purple gradient;
 * as of Feb 2020, Ricky said it's okay to leave it for Caliber and Home Point as well, for now
 */


var Dropdown = function Dropdown(_ref2) {
  var ariaLabelledbyId = _ref2.ariaLabelledbyId,
      menuList = _ref2.menuList,
      menuStyle = _ref2.menuStyle,
      toggleButton = _ref2.toggleButton,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["ariaLabelledbyId", "menuList", "menuStyle", "toggleButton"]);
  var toggleRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      menuContentIndex = _useState4[0],
      setMenuContentIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      menuCount = _useState6[0],
      setMenuCount = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      linkRefs = _useState8[0],
      setLinkRefs = _useState8[1];

  var menuRef = (0, _react.useRef)(null);
  var keyboardEvents = (0, _react.useCallback)(function (e) {
    var key = e.key,
        keyCode = e.keyCode,
        shiftKey = e.shiftKey;

    if (_Constant.TAB.includes(key || keyCode)) {
      if (isOpen) {
        e.preventDefault();

        if (shiftKey) {
          if (menuContentIndex === 0) {
            setOpen(false);
          }
        }
      }

      return;
    }

    if ([].concat((0, _toConsumableArray2.default)(_Constant.DOWN), (0, _toConsumableArray2.default)(_Constant.SPACE), (0, _toConsumableArray2.default)(_Constant.ENTER)).includes(key || keyCode)) {
      e.preventDefault();

      if (!isOpen) {
        setOpen(true);
        linkRefs.forEach(function (el) {
          return el.setAttribute('tabindex', 0);
        });
        linkRefs[0].focus();
        setMenuContentIndex(0);
      }
    } // If a mouse user clicks on Toggle, the down key should move focus onto the first menu item


    if (_Constant.DOWN.includes(key || keyCode)) {
      e.preventDefault();

      if (isOpen) {
        linkRefs.forEach(function (el) {
          return el.setAttribute('tabindex', 0);
        });
        linkRefs[0].focus();
        setMenuContentIndex(0);
      }
    } // If a mouse user clicks on Toggle, the esc key should close the menu


    if (_Constant.ESC.includes(key || keyCode)) {
      e.preventDefault();

      if (isOpen) {
        setOpen(false);
        linkRefs.forEach(function (el) {
          return el.setAttribute('tabindex', -1);
        });
        toggleRef.current.focus();
      }
    }
  }, [isOpen, menuContentIndex, linkRefs]);
  var menuKeyboardEvents = (0, _react.useCallback)(function (e) {
    var key = e.key,
        keyCode = e.keyCode;

    if (_Constant.TAB.includes(key || keyCode)) {
      if (isOpen) setOpen(false);
      linkRefs.forEach(function (el) {
        return el.setAttribute('tabindex', -1);
      });
      toggleRef.current.focus();
      return;
    }

    if (_Constant.DOWN.includes(key || keyCode)) {
      e.preventDefault();
      var newIndex = normalizeIndex(menuContentIndex + 1, menuCount);
      linkRefs[newIndex].focus();
      setMenuContentIndex(newIndex);
      return;
    }

    if (_Constant.UP.includes(key || keyCode)) {
      e.preventDefault();

      var _newIndex = normalizeIndex(menuContentIndex - 1, menuCount);

      linkRefs[_newIndex].focus();

      setMenuContentIndex(_newIndex);
      return;
    }

    if (_Constant.ESC.includes(key || keyCode)) {
      if (isOpen) {
        setOpen(false);
        linkRefs.forEach(function (el) {
          return el.setAttribute('tabindex', -1);
        });
        toggleRef.current.focus();
      }
    }
  }, [menuContentIndex, linkRefs, menuCount, isOpen]);
  (0, _react.useEffect)(function () {
    setMenuCount(menuList.length);
    setTimeout(function () {
      if (menuRef.current) {
        var refs = (0, _toConsumableArray2.default)(menuRef.current.children);
        setLinkRefs(refs.reduce(function (acc, ref) {
          var link = ref.children[0];
          ref.children[0].setAttribute('tabindex', -1);
          acc.push(link);
          return acc;
        }, []));
      }
    }, 0);
  }, [menuList]);
  (0, _react.useEffect)(function () {
    var handleClick = function handleClick() {
      setOpen(false);
    };

    window.addEventListener('click', handleClick);
    return function () {
      window.removeEventListener('click', handleClick);
    };
  });
  return /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({}, props, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }), /*#__PURE__*/_react.default.createElement(Toggle, {
    ref: toggleRef,
    type: "button",
    id: ariaLabelledbyId,
    onClick: function onClick() {
      setOpen(function (prev) {
        return !prev;
      }); // Place focus on the button so users can switch between the mouse and keyboard on Safari

      toggleRef.current.focus();
    },
    onKeyDown: keyboardEvents,
    onKeyUp: function onKeyUp(_ref3) {
      var key = _ref3.key,
          keyCode = _ref3.keyCode;

      if (_Constant.ENTER.includes(key || keyCode)) {
        setOpen(true);
      }
    },
    "aria-haspopup": true,
    "aria-expanded": isOpen
  }, toggleButton), /*#__PURE__*/_react.default.createElement(DropdownMenu, {
    onKeyDown: menuKeyboardEvents,
    ref: menuRef,
    isOpen: isOpen,
    "aria-hidden": !isOpen // ariaLabelledbyId={ariaLabelledbyId}
    ,
    style: menuStyle
  }, menuList.map(function (menuItem, index) {
    return /*#__PURE__*/_react.default.createElement(DropdownItem, {
      key: "menu-item-".concat(index)
    }, menuItem);
  })));
};

Dropdown.propTypes = {
  /** Establishes relationship between toggle button and dropdown */
  ariaLabelledbyId: _propTypes.default.string,

  /** Array that contains the items in the dropdown menu */
  menuList: _propTypes.default.arrayOf(_propTypes.default.element).isRequired,
  menuStyle: _propTypes.default.object,

  /** Toggles the dropdown menu open or closed */
  toggleButton: _propTypes.default.element.isRequired
};
Dropdown.defaultProps = {
  ariaLabelledbyId: 'mobile-dropdown-menu-button',
  menuStyle: {}
};
var _default = Dropdown;
exports.default = _default;